/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HotelImage } from './HotelImage';
import {
    HotelImageFromJSON,
    HotelImageFromJSONTyped,
    HotelImageToJSON,
    HotelImageToJSONTyped,
} from './HotelImage';
import type { PointsAmount } from './PointsAmount';
import {
    PointsAmountFromJSON,
    PointsAmountFromJSONTyped,
    PointsAmountToJSON,
    PointsAmountToJSONTyped,
} from './PointsAmount';
import type { FilterRate } from './FilterRate';
import {
    FilterRateFromJSON,
    FilterRateFromJSONTyped,
    FilterRateToJSON,
    FilterRateToJSONTyped,
} from './FilterRate';
import type { RoomInfo } from './RoomInfo';
import {
    RoomInfoFromJSON,
    RoomInfoFromJSONTyped,
    RoomInfoToJSON,
    RoomInfoToJSONTyped,
} from './RoomInfo';
import type { Tag } from './Tag';
import {
    TagFromJSON,
    TagFromJSONTyped,
    TagToJSON,
    TagToJSONTyped,
} from './Tag';
import type { TransferPartnerSummary } from './TransferPartnerSummary';
import {
    TransferPartnerSummaryFromJSON,
    TransferPartnerSummaryFromJSONTyped,
    TransferPartnerSummaryToJSON,
    TransferPartnerSummaryToJSONTyped,
} from './TransferPartnerSummary';
import type { CurrencyAmount } from './CurrencyAmount';
import {
    CurrencyAmountFromJSON,
    CurrencyAmountFromJSONTyped,
    CurrencyAmountToJSON,
    CurrencyAmountToJSONTyped,
} from './CurrencyAmount';

/**
 * 
 * @export
 * @interface HotelRateDelta
 */
export interface HotelRateDelta {
    /**
     * 
     * @type {Date}
     * @memberof HotelRateDelta
     */
    checkin?: Date;
    /**
     * 
     * @type {Date}
     * @memberof HotelRateDelta
     */
    checkout?: Date;
    /**
     * 
     * @type {string}
     * @memberof HotelRateDelta
     */
    checkinStr?: string;
    /**
     * 
     * @type {string}
     * @memberof HotelRateDelta
     */
    checkoutStr?: string;
    /**
     * 
     * @type {number}
     * @memberof HotelRateDelta
     */
    nights?: number;
    /**
     * Lowest total room rate
     * @type {number}
     * @memberof HotelRateDelta
     */
    lowestRate?: number;
    /**
     * Currency of lowest rate and nightly rate
     * @type {string}
     * @memberof HotelRateDelta
     */
    lowestRateCurrency?: string;
    /**
     * Average nightly rate for the lowest rate
     * @type {number}
     * @memberof HotelRateDelta
     */
    nightlyRate?: number;
    /**
     * 
     * @type {CurrencyAmount}
     * @memberof HotelRateDelta
     */
    bestRate?: CurrencyAmount;
    /**
     * 
     * @type {CurrencyAmount}
     * @memberof HotelRateDelta
     */
    bestNightlyRate?: CurrencyAmount;
    /**
     * 
     * @type {CurrencyAmount}
     * @memberof HotelRateDelta
     */
    lowestRefundableRate?: CurrencyAmount;
    /**
     * 
     * @type {CurrencyAmount}
     * @memberof HotelRateDelta
     */
    refundableNightlyRate?: CurrencyAmount;
    /**
     * 
     * @type {CurrencyAmount}
     * @memberof HotelRateDelta
     */
    lowestNonRefundableRate?: CurrencyAmount;
    /**
     * 
     * @type {CurrencyAmount}
     * @memberof HotelRateDelta
     */
    nonRefundableNightlyRate?: CurrencyAmount;
    /**
     * 
     * @type {CurrencyAmount}
     * @memberof HotelRateDelta
     */
    lowestSuiteRate?: CurrencyAmount;
    /**
     * 
     * @type {CurrencyAmount}
     * @memberof HotelRateDelta
     */
    suiteNightlyRate?: CurrencyAmount;
    /**
     * Likelihood of receiving a complimentary room upgrade based on room availability and user's loyalty tier. Only populated when the user has a matching loyalty account for the hotel's chain.
     * 
     * @type {string}
     * @memberof HotelRateDelta
     */
    upgradeLikelihood?: HotelRateDeltaUpgradeLikelihoodEnum;
    /**
     * True when the search check-in is within 14 days and Travelport inventory shows rooms at higher tiers than the base room category. Factual signal based on current availability, not a prediction.
     * 
     * @type {boolean}
     * @memberof HotelRateDelta
     */
    betterRoomsAvailable?: boolean | null;
    /**
     * Lowest rates keyed by filter type. Only populated for filters with matching rooms. Room type keys: suite, studio, standard. Bed type keys: 1_king, 1_queen, 2_queens, 2_double_beds.
     * 
     * @type {{ [key: string]: FilterRate; }}
     * @memberof HotelRateDelta
     */
    lowestRatesByFilter?: { [key: string]: FilterRate; };
    /**
     * Lowest points for any room at hotel for the search range
     * @type {number}
     * @memberof HotelRateDelta
     */
    lowestPoints?: number;
    /**
     * Average nightly points for the lowest points rate
     * @type {number}
     * @memberof HotelRateDelta
     */
    lowestNightlyPoints?: number;
    /**
     * 
     * @type {PointsAmount}
     * @memberof HotelRateDelta
     */
    lowestPointsAmount?: PointsAmount;
    /**
     * Distance from search location in m
     * @type {number}
     * @memberof HotelRateDelta
     */
    proximity?: number;
    /**
     * The percentile of the points deal
     * @type {number}
     * @memberof HotelRateDelta
     */
    pointsPercentile?: number;
    /**
     * The number of cents per pt
     * @type {number}
     * @memberof HotelRateDelta
     */
    pointRedemptionValue?: number;
    /**
     * The percentile of the cash deal
     * @type {number}
     * @memberof HotelRateDelta
     */
    cashPercentile?: number;
    /**
     * The score of the deal. A value between 0 and 10, where 10 is a great deal.
     * @type {number}
     * @memberof HotelRateDelta
     */
    cashDealScore?: number;
    /**
     * The score of the deal. A value between 0 and 10, where 10 is a great deal.
     * @type {number}
     * @memberof HotelRateDelta
     */
    pointsDealScore?: number;
    /**
     * The number of free nights for the points deal
     * @type {number}
     * @memberof HotelRateDelta
     */
    nightsFree?: number;
    /**
     * Transfer partners that it is worth using for this deal
     * @type {Array<TransferPartnerSummary>}
     * @memberof HotelRateDelta
     */
    transferPartnerDeals?: Array<TransferPartnerSummary>;
    /**
     * 
     * @type {Array<Tag>}
     * @memberof HotelRateDelta
     */
    tags?: Array<Tag>;
    /**
     * 
     * @type {number}
     * @memberof HotelRateDelta
     */
    vervotechPropertyId: number;
    /**
     * 
     * @type {boolean}
     * @memberof HotelRateDelta
     */
    available?: boolean;
    /**
     * 
     * @type {Array<HotelImage>}
     * @memberof HotelRateDelta
     */
    images?: Array<HotelImage>;
    /**
     * 
     * @type {Array<RoomInfo>}
     * @memberof HotelRateDelta
     */
    rooms?: Array<RoomInfo>;
}


/**
 * @export
 */
export const HotelRateDeltaUpgradeLikelihoodEnum = {
    None: 'none',
    Low: 'low',
    Medium: 'medium',
    High: 'high'
} as const;
export type HotelRateDeltaUpgradeLikelihoodEnum = typeof HotelRateDeltaUpgradeLikelihoodEnum[keyof typeof HotelRateDeltaUpgradeLikelihoodEnum];


/**
 * Check if a given object implements the HotelRateDelta interface.
 */
export function instanceOfHotelRateDelta(value: object): value is HotelRateDelta {
    if (!('vervotechPropertyId' in value) || value['vervotechPropertyId'] === undefined) return false;
    return true;
}

export function HotelRateDeltaFromJSON(json: any): HotelRateDelta {
    return HotelRateDeltaFromJSONTyped(json, false);
}

export function HotelRateDeltaFromJSONTyped(json: any, ignoreDiscriminator: boolean): HotelRateDelta {
    if (json == null) {
        return json;
    }
    return {
        
        'checkin': json['checkin'] == null ? undefined : (new Date(json['checkin'])),
        'checkout': json['checkout'] == null ? undefined : (new Date(json['checkout'])),
        'checkinStr': json['checkin_str'] == null ? undefined : json['checkin_str'],
        'checkoutStr': json['checkout_str'] == null ? undefined : json['checkout_str'],
        'nights': json['nights'] == null ? undefined : json['nights'],
        'lowestRate': json['lowest_rate'] == null ? undefined : json['lowest_rate'],
        'lowestRateCurrency': json['lowest_rate_currency'] == null ? undefined : json['lowest_rate_currency'],
        'nightlyRate': json['nightly_rate'] == null ? undefined : json['nightly_rate'],
        'bestRate': json['best_rate'] == null ? undefined : CurrencyAmountFromJSON(json['best_rate']),
        'bestNightlyRate': json['best_nightly_rate'] == null ? undefined : CurrencyAmountFromJSON(json['best_nightly_rate']),
        'lowestRefundableRate': json['lowest_refundable_rate'] == null ? undefined : CurrencyAmountFromJSON(json['lowest_refundable_rate']),
        'refundableNightlyRate': json['refundable_nightly_rate'] == null ? undefined : CurrencyAmountFromJSON(json['refundable_nightly_rate']),
        'lowestNonRefundableRate': json['lowest_non_refundable_rate'] == null ? undefined : CurrencyAmountFromJSON(json['lowest_non_refundable_rate']),
        'nonRefundableNightlyRate': json['non_refundable_nightly_rate'] == null ? undefined : CurrencyAmountFromJSON(json['non_refundable_nightly_rate']),
        'lowestSuiteRate': json['lowest_suite_rate'] == null ? undefined : CurrencyAmountFromJSON(json['lowest_suite_rate']),
        'suiteNightlyRate': json['suite_nightly_rate'] == null ? undefined : CurrencyAmountFromJSON(json['suite_nightly_rate']),
        'upgradeLikelihood': json['upgrade_likelihood'] == null ? undefined : json['upgrade_likelihood'],
        'betterRoomsAvailable': json['better_rooms_available'] == null ? undefined : json['better_rooms_available'],
        'lowestRatesByFilter': json['lowest_rates_by_filter'] == null ? undefined : (mapValues(json['lowest_rates_by_filter'], FilterRateFromJSON)),
        'lowestPoints': json['lowest_points'] == null ? undefined : json['lowest_points'],
        'lowestNightlyPoints': json['lowest_nightly_points'] == null ? undefined : json['lowest_nightly_points'],
        'lowestPointsAmount': json['lowest_points_amount'] == null ? undefined : PointsAmountFromJSON(json['lowest_points_amount']),
        'proximity': json['proximity'] == null ? undefined : json['proximity'],
        'pointsPercentile': json['points_percentile'] == null ? undefined : json['points_percentile'],
        'pointRedemptionValue': json['point_redemption_value'] == null ? undefined : json['point_redemption_value'],
        'cashPercentile': json['cash_percentile'] == null ? undefined : json['cash_percentile'],
        'cashDealScore': json['cash_deal_score'] == null ? undefined : json['cash_deal_score'],
        'pointsDealScore': json['points_deal_score'] == null ? undefined : json['points_deal_score'],
        'nightsFree': json['nights_free'] == null ? undefined : json['nights_free'],
        'transferPartnerDeals': json['transfer_partner_deals'] == null ? undefined : ((json['transfer_partner_deals'] as Array<any>).map(TransferPartnerSummaryFromJSON)),
        'tags': json['tags'] == null ? undefined : ((json['tags'] as Array<any>).map(TagFromJSON)),
        'vervotechPropertyId': json['vervotech_property_id'],
        'available': json['available'] == null ? undefined : json['available'],
        'images': json['images'] == null ? undefined : ((json['images'] as Array<any>).map(HotelImageFromJSON)),
        'rooms': json['rooms'] == null ? undefined : ((json['rooms'] as Array<any>).map(RoomInfoFromJSON)),
    };
}

export function HotelRateDeltaToJSON(json: any): HotelRateDelta {
    return HotelRateDeltaToJSONTyped(json, false);
}

export function HotelRateDeltaToJSONTyped(value?: HotelRateDelta | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'checkin': value['checkin'] == null ? value['checkin'] : value['checkin'].toISOString().substring(0,10),
        'checkout': value['checkout'] == null ? value['checkout'] : value['checkout'].toISOString().substring(0,10),
        'checkin_str': value['checkinStr'],
        'checkout_str': value['checkoutStr'],
        'nights': value['nights'],
        'lowest_rate': value['lowestRate'],
        'lowest_rate_currency': value['lowestRateCurrency'],
        'nightly_rate': value['nightlyRate'],
        'best_rate': CurrencyAmountToJSON(value['bestRate']),
        'best_nightly_rate': CurrencyAmountToJSON(value['bestNightlyRate']),
        'lowest_refundable_rate': CurrencyAmountToJSON(value['lowestRefundableRate']),
        'refundable_nightly_rate': CurrencyAmountToJSON(value['refundableNightlyRate']),
        'lowest_non_refundable_rate': CurrencyAmountToJSON(value['lowestNonRefundableRate']),
        'non_refundable_nightly_rate': CurrencyAmountToJSON(value['nonRefundableNightlyRate']),
        'lowest_suite_rate': CurrencyAmountToJSON(value['lowestSuiteRate']),
        'suite_nightly_rate': CurrencyAmountToJSON(value['suiteNightlyRate']),
        'upgrade_likelihood': value['upgradeLikelihood'],
        'better_rooms_available': value['betterRoomsAvailable'],
        'lowest_rates_by_filter': value['lowestRatesByFilter'] == null ? undefined : (mapValues(value['lowestRatesByFilter'], FilterRateToJSON)),
        'lowest_points': value['lowestPoints'],
        'lowest_nightly_points': value['lowestNightlyPoints'],
        'lowest_points_amount': PointsAmountToJSON(value['lowestPointsAmount']),
        'proximity': value['proximity'],
        'points_percentile': value['pointsPercentile'],
        'point_redemption_value': value['pointRedemptionValue'],
        'cash_percentile': value['cashPercentile'],
        'cash_deal_score': value['cashDealScore'],
        'points_deal_score': value['pointsDealScore'],
        'nights_free': value['nightsFree'],
        'transfer_partner_deals': value['transferPartnerDeals'] == null ? undefined : ((value['transferPartnerDeals'] as Array<any>).map(TransferPartnerSummaryToJSON)),
        'tags': value['tags'] == null ? undefined : ((value['tags'] as Array<any>).map(TagToJSON)),
        'vervotech_property_id': value['vervotechPropertyId'],
        'available': value['available'],
        'images': value['images'] == null ? undefined : ((value['images'] as Array<any>).map(HotelImageToJSON)),
        'rooms': value['rooms'] == null ? undefined : ((value['rooms'] as Array<any>).map(RoomInfoToJSON)),
    };
}

